<template>
  <div class="compair-layout--box">
    <div class="compair-layout--box-header">
      <h3>Filter</h3>
      <div class="vx-row">
        <div class="vx-col w-full lg:w-1/3">
          <DataInput
            v-model="filter.fromTime"
            type="date"
            label="Von"
            name="from"
            :config="{
              altFormat: 'd.m.Y H:i',
              dateFormat: 'Y-m-d H:i'
            }"
          />
        </div>
        <div class="vx-col w-full lg:w-1/3">
          <DataInput
            v-model="filter.toTime"
            type="date"
            label="Bis"
            name="to"
            :config="{
              altFormat: 'd.m.Y H:i',
              dateFormat: 'Y-m-d H:i'
            }"
          />
        </div>
        <div class="vx-col w-full lg:w-1/3">
          <DataInput
            v-model="filter.interval"
            type="select"
            :options="[
              { code: 1440, label: 'Täglich' },
              { code: 10080, label: '7 Tage' }
            ]"
            placeholder="Interval"
            name="interval"
            label="Interval"
          />
        </div>
        <!-- <div class="vx-col w-full lg:w-1/3">
          <DataInput
            v-model="filter.metrics"
            type="select"
            :options="[
              { code: ['VISITORS', 'APPLICATIONS'], label: 'Alles' },
              { code: ['VISITORS'], label: 'Besucher' },
              { code: ['APPLICATIONS'], label: 'Bewerbungen' }
            ]"
            placeholder="Metrics"
            name="interval"
            label="Metrics"
          />
        </div> -->
      </div>
    </div>
    <div class="compair-layout--box-body">
      <template v-if="datacollection">
        <VacancyStatChart
          v-if="filter"
          ref="chart"
          :chart-data="datacollection"
          :height="250"
          :max="chartMaxY"
          :options="options"
        ></VacancyStatChart>
        <vacancy-compare-chart :override-data-collection="datacollection" />
      </template>
      <template v-else>
        Für die angegeben Filter gibt es aktuell keine Daten.
      </template>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import updateChartYLegendMixin from "@/mixins/updateChartYLegendMixin";
import DataInput from "@/components/ui/DataInput";
import VacancyStatChart from "@/components/bi/charts/StatChart";
import VacancyCompareChart from "../../stats/VacancyCompareChart.vue";

export default {
  components: {
    DataInput,
    VacancyStatChart,
    VacancyCompareChart
  },
  mixins: [updateChartYLegendMixin],
  props: {
    vacancies: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      internalMaxY: null,
      filter: {
        fromTime: moment().subtract(7, "days"),
        toTime: null,
        interval: 1440
      },
      datacollection: null
    };
  },
  apollo: {
    biStats: {
      query: gql`
        query BiStats($filter: BIStatsFilter!) {
          biStats(filter: $filter) {
            interval
            numDatapoints
            datapoints {
              time
              interval
              amount
              amountUnique
              duration
              type
            }
          }
        }
      `,
      variables() {
        return {
          filter: {
            vacancyID: this.vacancies,
            interval: this.filter.interval,
            fromTime: this.filter.fromTime,
            toTime: this.filter.toTime,
            metrics: [
              "VISITORS",
              "APPLICATIONS_SENT",
              "APPLICATIONS",
              "MANUAL_APPLICATIONS",
              "VIEW_UNLOAD"
            ]
          }
        };
      }
    }
  },
  computed: {
    chartMaxY() {
      return Math.max(this.internalMaxY, this.maxY);
    }
  },
  watch: {
    biStats(stats) {
      if (!stats.datapoints) {
        this.datacollection = null;
        return;
      }

      stats.datapoints.sort((a, b) =>
        a.time > b.time ? 1 : a.time < b.time ? -1 : 0
      );

      let labels = [];
      for (let data of stats.datapoints) {
        let time = moment(data.time);
        if (labels.findIndex(val => val.diff(time) === 0) === -1) {
          labels.push(time);
        }
      }
      let maxValue = 1;
      let visitorsData = [];
      let visitorsUniqueData = [];
      let applicationsData = [];
      let applicationsWebData = [];
      let applicationsManualData = [];
      let sessionDurations = [];
      for (let label of labels) {
        let visitors = 0;
        let visitorsUnique = 0;
        let applications = 0;
        let manualApplications = 0;
        let webApplications = 0;
        let sessionDuration = 0;
        for (let data of stats.datapoints) {
          let time = moment(data.time);
          if (time.diff(label) === 0 && data.type === "VISITORS") {
            visitors = data.amount;
          } else if (
            time.diff(label) === 0 &&
            data.type === "UNIQUE_VISITORS"
          ) {
            visitorsUnique = data.amount;
          } else if (time.diff(label) === 0 && data.type === "APPLICATIONS") {
            applications = data.amount;
          } else if (
            time.diff(label) === 0 &&
            data.type === "APPLIACTIONS_WEB"
          ) {
            webApplications = data.amount;
          } else if (
            time.diff(label) === 0 &&
            data.type === "APPLICATIONS_MANUAL"
          ) {
            manualApplications = data.amount;
          } else if (time.diff(label) === 0 && data.type === "VIEW_UNLOAD") {
            sessionDuration = data.duration;
          }
        }

        const currentMaxValue = Math.max(
          visitors,
          visitorsUnique,
          applications
        );
        if (currentMaxValue > maxValue) {
          maxValue = currentMaxValue;
        }

        visitorsData.push(visitors);
        visitorsUniqueData.push(visitorsUnique);
        applicationsData.push(applications);
        applicationsWebData.push(webApplications);
        applicationsManualData.push(manualApplications);
        sessionDurations.push(sessionDuration);
      }

      this.internalMaxY = maxValue;

      this.datacollection = {
        labels,
        datasets: [
          {
            label: "Besucher (eindeutig)",
            borderColor: "#13358e",
            data: visitorsUniqueData,
            fill: true,
            backgroundColor: "rgba(19, 53, 142, 0.8)",
            pointHoverBackgroundColor: "#000000",
            lineTension: 0
          },
          {
            label: "Besuche",
            borderColor: "#55c400",
            data: visitorsData,
            fill: true,
            backgroundColor: "rgba(85, 196, 0, 0.8)",
            pointHoverBackgroundColor: "#000000",
            lineTension: 0
          },
          {
            label: "Bewerbungen",
            borderColor: "#48c6ef",
            data: applicationsData,
            fill: true,
            backgroundColor: "rgba(72, 198, 239, 0.8)",
            pointHoverBackgroundColor: "#000000",
            lineTension: 0
          },
          {
            label: "Online Bewerbungen",
            borderColor: "#d1232b",
            data: applicationsWebData,
            fill: true,
            backgroundColor: "rgba(209, 35, 43, 0.8)",
            pointHoverBackgroundColor: "#000000",
            lineTension: 0,
            hidden: true
          },
          {
            label: "Durchschnittliche Sitzungsdauer (Sekunden)",
            borderColor: "#0a1f57",
            data: sessionDurations,
            fill: true,
            backgroundColor: "rgba(10, 31, 87, 0.8)",
            pointHoverBackgroundColor: "#000000",
            lineTension: 0,
            hidden: true
          },
          {
            label: "Manuelle Bewerbungen",
            borderColor: "#0a1f57",
            data: applicationsManualData,
            fill: true,
            backgroundColor: "rgba(10, 31, 87, 0.8)",
            pointHoverBackgroundColor: "#000000",
            lineTension: 0,
            hidden: true
          }
        ]
      };
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/components/bi/main";
</style>
